export default "__VITE_ASSET__D$ZN0gjn__"